<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web" style="height:auto">
            <br />

            <div class="ml-3 mr-3">
              <CRow>
                <CCol>
                  <img src="../../assets/img/icon/iconUserBlue.svg" />
                </CCol>
                <CCol style="margin-left: -330px">
                  <label class="label-blue ml-2" style="color: #007cef"
                    >Student</label
                  >
                  <br />
                  <label
                    class="label-blue ml-2"
                    style="color: ##000a2c; font-weight: 400"
                    >Group of two for {{ student.studentName }}
                  </label>
                </CCol>
              </CRow>
              <hr />

              <CRow>
                <CCol>
                  <img src="../../assets/img/icon/iconBookBlue.svg" />
                </CCol>
                <CCol style="margin-left: -330px">
                  <label class="label-blue ml-2" style="color: #007cef"
                    >Subject</label
                  >
                  <br />
                  <label
                    ><input
                      class="label-blue ml-2"
                      style="
                        color: #000a2c;
                        font-weight: 400;
                        background-color: transparent;
                        border: 0px solid;
                      "
                      v-model="Subject"
                      disabled
                  /></label>
                  <br />
                  <label
                    ><input
                      class="label-blue ml-2"
                      style="
                        color: #000a2c;
                        font-weight: 400;
                        background-color: transparent;
                        border: 0px solid;
                      "
                      v-model="Language"
                      disabled
                  /></label>
                </CCol>
              </CRow>
              <hr />

              <CRow>
                <CCol>
                  <img src="../../assets/img/icon/iconBookBlue.svg" />
                </CCol>
                <CCol style="margin-left: -330px">
                  <label class="label-blue ml-2" style="color: #007cef"
                    >Duration Week
                  </label>
                  <br />
                  <label
                    ><input
                      class="label-blue ml-2"
                      style="
                        color: #000a2c;
                        font-weight: 400;
                        background-color: transparent;
                        border: 0px solid;
                      "
                      v-model="Duration"
                      disabled
                    />weeks</label
                  >
                </CCol>
              </CRow>

              <br />

              <CRow>
                <CCol>
                  <label
                    class="label-blue"
                    style="color: #000a2c; font-weight: 400"
                    >Available Credits</label
                  >
                </CCol>
                <CCol>
                  <label
                    class="float-right label-blue"
                    style="color: #000a2c"
                    >{{ wallet.currentAmount }}</label
                  >
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <label
                    class="label-blue"
                    style="color: #000a2c; font-weight: 400"
                    >Charged Credits</label
                  >
                </CCol>
                <CCol>
                  <label
                    class="float-right label-blue"
                    style="color: #f85954"
                    >{{ price.Rate }}</label
                  >
                </CCol>
              </CRow>

              <hr />

              <CRow>
                <CCol>
                  <label
                    class="label-blue"
                    style="color: #000a2c; font-weight: 400"
                    >Remaining Credits</label
                  >
                </CCol>
                <CCol>
                  <label
                    class="float-right label-blue"
                    style="color: #000a2c"
                    >{{ remain }}</label
                  >
                </CCol>

                <div style="clear: both"></div>
              </CRow>
              <br /><br />
              <CCol sm="12" class="">
                <CRow class="">
                  <CCard>
                    <CRow class="p-2">
                    
                      <CCol sm="4" lg="4"> <label>Language</label></CCol>
                      <CCol sm="8" lg="8">
                        <span v-for="item in languages" v-bind:key="item.id">
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          />
                            {{ item.name }}
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Session</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span
                          v-for="item in sessions"
                          v-bind:key="item.id"
                          style="font-size: 15px"
                        >
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          />
                            {{ item.name }}
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Time</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span
                          v-for="item in times"
                          v-bind:key="item.id"
                          style="font-size: 15px"
                        >
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          />
                            {{ item.name }}
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Class Duration</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <!-- <span v-for="item in dur" v-bind:key="item.id">
                          <input
                            name="item.id"
                            type="radio"
                            value="item.id"
                            v-model="durationID"
                            @change="durationID = item.id"
                            class="mr-2 ml-2"
                          />
                            {{ item.name }}
                        </span> -->

                        <span v-if="dur.length >= 2">
                          <input
                            name="dur[1].id"
                            type="radio"
                            value="dur[1].id"
                            v-model="durationID"
                            @change="durationID = dur[1].id"
                            class="mr-2 ml-2"
                          />
                          {{ dur[1].name }}
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Start Time</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <CInput type="datetime-local" v-model="StartTime" />
                      </CCol>
                    </CRow>
                  </CCard>
                </CRow>
                <div style="clear: both"></div>
              </CCol>

              <!-- <input type="checkbox" />
                <label class="label-blue" style="color: #000A2C; font-weight: 400;">Set class recurring every week</label> -->
              <div class="text-center m-0">
                <CCol sm="12">
                  <div v-if="SuccessMessage == true">
                    <CAlert color="success"
                      >You have Successfully Submit Waiting List</CAlert
                    >
                    <CButton
                      color="info"
                      class="btn-select-green mt-5"
                      block
                    >
                      Success Submit Waiting List
                    </CButton>
                  </div>
                  <div v-if="SubmitButton == true">
                    <CButton
                      color="info"
                      class="btn-select-blue mt-5"
                      @click="DirectGroupOfTwo"
                      block
                    >
                      Add To Waiting List
                    </CButton>
                    <br /><br />
                  </div>
                </CCol>

                <!-- kalau credit tak cukup -->
                <!-- <CButton  style="
                    position: fixed;
                    bottom: 30px;
                    left: 0px;
                    right: 0px;
                    text-align: center;
                    margin: 0 auto;
                    " color="info" class="btn-select-blue mt-5" @click="GoToTopup()">
                    Topup Credit
                  </CButton> -->
              </div>
            </div>
          </div>

          <CModal
            title="Credit not enough."
            style="
              position: relative;
              width: 375px;
              height: 900px;
              border-radius: 32px;
            "
            size=""
            :show.sync="popupTopup"
          >
            <p></p>
            <div class="ml-3 mr-3">
              <label>Please topup your credit to proceed to Find Tutor.</label>
            </div>
            <br />
            <template #footer>
              <CButton color="success" @click="RefreshModal()">Cancel</CButton>

              <CButton color="info" @click="GoToTopup()">Topup</CButton>
            </template>
          </CModal>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

    <div style="clear: both"></div>
    <div class="header-top">Summary</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
      <br />
      
    </div>
    <div style="clear: both"></div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

export default {
  components: {
    MainlayoutBottom,
  },
  data: function () {
    return {
      user: {},
      subject: [],
      student: {},
      FilterSubject: [],
      StudentId: this.$route.query.studentId,
      GradeId: this.$route.query.gradeId,
      SubjectId: this.$route.query.subjectId,
      Subject: this.$route.query.subjectName,
      LanguageId: this.$route.query.languageId,
      Language: this.$route.query.language,
      TeacherId: this.$route.query.teacher,
      DayId: this.$route.query.dayId,
      Day: this.$route.query.day,
      HourId: this.$route.query.hourId,
      Hour: this.$route.query.hour,
      DurationId: this.$route.query.durationId,
      Duration: this.$route.query.durationWeek,
      SubmittedForm: false,
      SearchQuery: "",
      SelectedSubject: "",

      studentProfileAuthorize: "",

      wallet: {},
      price: {},
      language: [],
      popupTopup: false,
      // remaining: this.remain,
      SuccessMessage: false,
      SubmitButton: true,

      languages: [],
      sessions: [],
      times: [],
      dur: [],
      StartTime: "",
      durationID: "",
      remain: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.GetLanguages();
      this.GetSession();
      this.GetTimes();
      this.GetDurations();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GoHomePage() {
      this.$router.push("FTClassType");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            //this.GetSubject();
            this.GetStudent(this.$route.query.studentId);
            this.GetWalletAmount(this.user.id);
            this.GetPriceRate(
              this.$route.query.gradeId,
              this.$route.query.durationId
            );
            this.GetLanguage();
          }
        });
    },

    GetStudent() {
      this.$API
        .get(
          this.$StudentProfile + "?studentId=" + this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.student = response.data;
            //this.studentid = this.student.id;
            console.log("student", this.student);
          }
        });
    },

    GetWalletAmount() {
      this.$API
        .get(this.$EwalletAmount + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.wallet = response.data;
            console.log("current", this.wallet.currentAmount);
          }
        });
    },

    GetPriceRate() {
      this.$API
        .get(
          this.$GetPrice +
            "?gradeId=" +
            this.$route.query.gradeId +
            "&durationId=" +
            2,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.price = response.data;
            console.log("rate", this.price.Rate);

            let available = this.wallet.currentAmount;
            let charged = this.price.Rate;
            let remaining = available - charged;
            this.remain = remaining;
            console.log("REMAIN", this.remain);
          }
        });
    },

    //   GetAuthorizeProfile() {
    //   this.$API
    //     .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.studentProfileAuthorize = response.data;
    //         this.photoURL =
    //           "https://pickiddo.com" + this.studentProfileAuthorize;
    //       }
    //     });
    // },
    // GetSubject() {
    //   this.$API
    //     .get(this.$SubjectListAuthorize, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.subject = response.data;
    //         this.FilterSubject = this.subject;
    //       }
    //     });
    // },

    GoToTopup() {
      this.$router.push("/ParentProfile/Topup");
    },

    GoBack() {
      this.$router.back();
    },

    GetLanguage() {
      this.$API
        .get(this.$Languages, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.language = response.data;
          }
        });
    },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurations() {
      return this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    DirectGroupOfTwo()
    {    
       if(this.wallet.currentAmount >= 0) {
        const formData = new FormData();

        formData.append("IsGroup", true);
        formData.append("StudentId", this.$route.query.studentId);
        formData.append("TeachingSubjectId", this.$route.query.subjectId);
        formData.append("TeachingGradeId", this.$route.query.gradeId);
        formData.append("DurationId", this.durationID);
        formData.append("DataMessage", this.$route.query.subjectName);
        formData.append("teacherId", this.$route.query.teacher);
        formData.append("StartTime", this.StartTime);

        var combinedLanguage = [];
        for (let i in this.languages) {
          let item = this.languages[i];
          combinedLanguage.push({
            LanguageId: item.id,
            IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
          });
        }

        let languageData = JSON.stringify(combinedLanguage);
        formData.append("Language", languageData);

        var combinedSession = [];
        for (let i in this.sessions) {
          let item = this.sessions[i];
          combinedSession.push({
            SessionId: item.id,
            IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
          });
        }

        let sessionData = JSON.stringify(combinedSession);
        formData.append("Session", sessionData);

        var combinedTime = [];
        for (let i in this.times) {
          let item = this.times[i];
          combinedTime.push({
            TimeId: item.id,
            IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
          });
        }

        let timeData = JSON.stringify(combinedTime);
        formData.append("Time", timeData);

        return this.$API
          .post(this.$InsertDirectFindTutorGroupingStud1, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (
              response.status == 200 &&
              response.data != null &&
              response.data > 0
            ) {

              this.findTutorID = response.data;

              const formData = new FormData();

      formData.append("StudentId", this.StudentId);
      formData.append("GradeId", this.GradeId);
      formData.append("SubjectId", this.SubjectId);
      formData.append("teacherId", this.TeacherId);
      formData.append("NumberOfWeek", this.Duration);
      formData.append("LanguageId", this.LanguageId);
      formData.append("FindTutorId",  this.findTutorID);
      formData.append("ScheduleDateTime", this.StartTime);


      return this.$API
        .post(this.$CreateGroupWaitingList, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            // this.$dialog
            //   .alert("Request Sent.")
            // this.SuccessMessage = true;
            // this.SubmitButton = false;
            this.$router.push("FTClassType");
         
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        })
            
              // this.$dialog
              // .alert("Success.")
              // this.currentBtn = false;
              // this.SuccessMessage = true;
            } else {
              this.$dialog
              .alert("Error.")
              this.errorModal = true;
            }
          })
          .catch((error) => {
            if (error.response) {
              this.$dialog
                .alert("Error.")
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
      else {
        this.popupTopup = true;
      }  

    }
  },

  async RefreshModal() {
    this.popupTopup = false;
  },

  GoToAllSet() {
    this.$router.push("FTAllSet");
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");


.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.label-blue {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 0px;
}
</style>
  